import {HTTP} from "@/services/HttpServices";


export async function getSignedUrlForPut(fileType: string, filePath: string) {
    let url = `/public/integrations/s3/signed-url/put?s3key=${encodeURIComponent(filePath)}`;
    if (fileType) {
        url += `&contentType=${encodeURIComponent(fileType)}`;
    }
    return HTTP.get(url);
}

export async function getSignedUrlForGet(filePath: string) {
    return HTTP.get("/public/integrations/s3/signed-url/get?s3key=" + encodeURIComponent(filePath));
}

